module.exports = __webpack_public_path__ + "static/winter3-17e4eff235ee38b6b6886484e1df9e9b.jpg";